import { getType } from 'typesafe-actions'

import { createMiddleware, EventsMapper } from 'redux-beacon'
import { ActionTypes } from '../actions/upload'
import { pageView } from '../actions/app'

import { uploadEndEvent, uploadStartEvent, pageViewEvent } from './definitions'
import wtaAnalytics from './wtaAnalytics'

const wta = wtaAnalytics()

export const eventsMap: EventsMapper = action => {
  if (!window.wtaCmd) {
    return []
  }
  switch (action.type) {
    case ActionTypes.UPLOAD_START: {
      return uploadStartEvent
    }
    case ActionTypes.UPLOAD_END: {
      return uploadEndEvent
    }
    case getType(pageView): {
      return pageViewEvent // defined in definitions.ts
    }
    default: {
      return []
    }
  }
}

export const wtaMiddleware = createMiddleware(eventsMap, wta)
